module.exports = __webpack_public_path__ + "assets/toolbar-edit-icon-active.3b4010ff.svg";